// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"e45ffc49","198":"35be0849","703":"54bcd8bf","802":"fe97188e","921":"e846917c"}[chunkId] + ".chunk.js";
};